<template>
    <v-btn block dark color="#25D366" class="h-50" @click="openWhatsAppGroup()">
        <v-icon dark style="padding-right: 10px;">
            mdi-whatsapp
        </v-icon>WhatsApp Group
    </v-btn>
</template>

<script>
    import appSettings from "../../../mixins/config/appSettings";
    import resourcesApi from "@/api/resources/resourcesApi";
    import vuetify from "@/plugins/vuetify";
    import store from "@/store";

    export default {
        name: "WhatsappGroupButton",
        data : () => {
            return {
                WAChatLink : "https://chat.whatsapp.com/",
            }
        },
        mixins: [appSettings],
        methods : {
          async openWhatsAppGroup() {
            let code = await this.getWhatsAppGroupCode();
            if(code){
              window.open(this.WAChatLink + code, '_blank');
            }
          },
          async getWhatsAppGroupCode() {
            await this.$store.dispatch('setLoadingResourceState', true);
            var groupCode = null;
            var errorMessage = null;
            await resourcesApi.getDefaultWhatsAppGroupCode().then(response => {
              if (response.data !== undefined && response.data !== null) {
                if (response.data.group_code) {
                  groupCode = response.data.group_code;
                }
              }
            }).catch((error) => {
              if (error.reponse.data !== undefined &&
                  error.reponse.data !== null &&
                  error.reponse.data.status !== undefined
              ) {
                switch (error.reponse.data.status) {
                  case 'no-default-code-found':
                    errorMessage = vuetify.lang.t('$vuetify.whatsAppGroup.errors.notFound')
                    break;
                  default:
                    errorMessage = vuetify.lang.t('$vuetify.whatsAppGroup.errors.unknown')
                    break;
                }
              }else{
                errorMessage = vuetify.lang.t('$vuetify.whatsAppGroup.errors.unknown')
              }

            });
            await this.$store.dispatch('setLoadingResourceState', false);

            if(errorMessage){
              store.commit('launchSnackbarMessage', errorMessage);
            }
            return groupCode;
          }
        }
    }
</script>

<style scoped>


</style>